import * as React from "react";
const SvgFiRrDumpsterFire = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dumpster-fire_svg__a)">
      <path
        fill="#062147"
        d="M9 18H5.681a3.02 3.02 0 0 1-2.99-2.751L2.084 8h19.83l-.16 1.917a1 1 0 0 0 .913 1.08.99.99 0 0 0 1.079-.914L24 7V5c0-2.757-2.243-5-5-5H5C2.243 0 0 2.243 0 5l.004 1.982C.004 6.989 0 6.994 0 7c0 .007.004.012.004.019v.064l.694 8.332A5.01 5.01 0 0 0 3 19.207V20.5C3 22.43 4.57 24 6.5 24s3.5-1.57 3.5-3.5V19a1 1 0 0 0-1-1m2-12H8V2h3zm2-4h3v4h-3zm9 3 .002 1H18V2h1c1.654 0 3 1.346 3 3M5 2h1v4H2V5c0-1.654 1.346-3 3-3m14.565 8.496c-.584-.518-1.134-.492-1.412-.43-.272.061-.774.268-1.072.964-.32.747-.473 1.586-.608 2.328-.072.398-.18.987-.299 1.348-.051-.129-.214-.591-.25-.679-.253-.607-.738-.989-1.3-1.023-.567-.044-1.067.277-1.379.829C12.737 14.73 12 16.8 12 18.001A6.006 6.006 0 0 0 17.967 24c2.057 0 4.01-1.144 5.157-3.043 1.908-3.16.711-6.681-3.559-10.461m1.846 9.426a4.5 4.5 0 0 1-1.518 1.518c.212-.721-.005-1.55-.566-2.112l-.769-1.096a.79.79 0 0 0-1.115 0l-.77 1.096c-.585.585-.792 1.46-.532 2.202A4 4 0 0 1 14 18.001c0-.47.234-1.347.515-2.112.293.569.749 1.112 1.511 1.112 1.816 0 2.163-1.898 2.415-3.285.08-.436.161-.882.273-1.292 3.151 2.936 4.009 5.328 2.697 7.498"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dumpster-fire_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDumpsterFire;
